export const defaultControlsOptions = {
  show: true,
  position: "middle",
  leftControlIcon: null,
  rightControlIcon: null,
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  shape: "rectangle",
  width: "auto",
  height: "auto",
  iconHeight: "32",
  iconWidth: "32",
  iconFill: "#FFFFFF",
  borderRadius: "3px"
};

export const defaultIndicatorOptions = {
  show: true,
  shape: "pill",
  height: "5px",
  width: "20px",
  activeColor: "rgba(0,0,0,0.75)",
  inactiveColor: "rgba(255,255,255,0.75)",
  border: "none",
  boxShadow: "0 0 3px rgba(0, 0, 0, 0.16), 0 0 3px rgba(0, 0, 0, 0.23)"
};
